import { useCtaTracking, type UseCtaTrackingOptions } from '@lib/hooks/use-cta-tracking'

import { Button, type ButtonProps } from '@components/ui-core/button/button'

interface CtaProps {
  placement: UseCtaTrackingOptions['placement']
  category: Extract<ButtonProps['category'], 'primary' | 'secondary'>
  disabled: boolean
  label: string
  href: string
  className?: string
}

export const CtaButton = (props: CtaProps) => {
  const { placement, category, label, disabled, className, href } = props
  const { trackAndNavigate: onCtaClick } = useCtaTracking({ placement })
  return (
    <Button
      category={category}
      disabled={disabled}
      className={className}
      href={href}
      // Google Tag Manager will decorate href value (add query params) after page loads so we must pass the href value to the onClick handler instead of directly using the url value
      onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault()
        const href = e.currentTarget.href
        onCtaClick('Upgrade', label, category, href)
      }}
    >
      {label}
    </Button>
  )
}
